import styled from 'styled-components';

const Title = styled.div`
  text-align: center;
`;

export default Title;
